<template lang="pug">
.send-message-detail
  .contents.d-flex.flex-row
    .send-message
      SendMessageDetailContent(v-model="message" :readCount="readCount" :unreadCount="unreadCount"
        @onSendTargetList="onSendTargetList" @onPreview="onPreview" @onRead="onRead" @onUnread="onUnread")
    .reply-messages
      .reply-list(v-show="_detailType == 'list'")
        SendMessageReplyListTable(v-model="replyItems" :fields="replyFields" :isLoading="replyLoading" :type="0" @onMessage="onMessage" @onReadSwitch="onReadSwitch")
      .reply-detail(v-show="_detailType == 'detail'")
        SendMessageReplyInputBox(v-model="replyDetailText" :message="replyDetailMessage" @onReply="onReply" @onBack="onBack")
      .shared-reply-detail(v-show="_detailType == 'sharedDetail'")
        SendMessageSharedReplyInputBox(v-model="sharedReplyDetailText" :messages="sharedReplyDetailMessages" :showReplyInput="_showReplyInput"
          :existFamily="existFamilyForSharedReplyTab" :readed="sharedReaded"
          @onReply="onSharedReply" @onReadSwitch="onSharedReadSwitch")

  SendMessageFilePreviewModal(ref="previewModal")
  SendMessageReadFamiliesModal(v-model="showSendMessageReadFamiliesModal" :families="targetSendMessageReadFamilies"
    :csvTypeName="sendMessageCsvTypeName" :sendMessageTitle="sendMessageTitle" :showReadDatetime="showReadDatetime")

  //- 個別返信確認モーダル
  OkCancelModal(v-model="showReplyMessageModal" title="メッセージを送信しますか？" @ok="registerReplyMessage(replyTargetItem)")
  //- 共有メッセージ返信確認モーダル
  OkCancelModal(v-model="showSharedReplyMessageModal" title="メッセージを送信しますか？" @ok="registerSharedReplyMessage")
  //- TODO 個別・共有メッセージ返信完了モーダル
  OkModal(v-model="showSendMessageSuccessModal" title="メッセージ送信を受け付けました。" @ok="onReplySuccessOk")

  PageLoading(:isBusy="isBusy" :message="loadingMessage")
</template>

<script lang="ts">
import { Component, Inject, Prop, Vue } from "vue-property-decorator";
import { userStore } from "@/store/store";

import Setting from "../../../../public/setting.json";
import S3UrlService from "@/commons/services/S3Url";
import SendMessageReadCountsService, { SendMessageReadCountsModel } from "@/commons/services/SendMessageReadCounts";
import SendMessageReadFamiliesService, { SendMessageReadFamilyModel } from "@/commons/services/SendMessageReadFamilies";
import SendMessageRepliesService, { SendMessageRepliesPostModel, SendMessageReplyModel, SendMessageReplySenderType } from "@/commons/services/SendMessageReplies";
import SendMessageRepliesFamiliesService, { SendMessageRepliesFamilyPatchModel } from "@/commons/services/SendMessageRepliesFamilies";
import FamiliesService, { FamilyGetModel } from "@/commons/services/Families";

import PageLoading from "@/pc/basics/PageLoading.vue";
import OkCancelModal from "@/pc/basics/OkCancelModal.vue";
import OkModal from "@/pc/basics/OkModal.vue";
import SendMessageFilePreviewModal from "@/pc/components/modals/SendMessageFilePreviewModal.vue";
import SendMessageDetailContent from "@/pc/containers/sendMessages/SendMessageDetailContent.vue";
import SendMessageReplyListTable, {
  SendMessageReplyListTableItem,
  SendMessageReplyListTableField,
  SendMessageReplyListTableType
} from "@/pc/containers/sendMessages/SendMessageReplyListTable.vue";
import SendMessageReplyInputBox from "@/pc/containers/sendMessages/SendMessageReplyInputBox.vue";
import SendMessageSharedReplyInputBox, { SendMessageSharedReplyDetailBoxMessage } from "@/pc/containers/sendMessages/SendMessageSharedReplyInputBox.vue";

import SendMessageReadFamiliesModal from "@/pc/components/modals/SendMessageReadFamiliesModal.vue";
import { SendMessageHistoryTableItem } from "@/pc/containers/sendMessages/SendMessageHistoryTable.vue";

/**
 * メッセージ送信詳細コンポーネント
 */
@Component({
  components: {
    PageLoading,
    OkCancelModal,
    OkModal,
    SendMessageFilePreviewModal,
    SendMessageDetailContent,
    SendMessageReplyListTable,
    SendMessageReadFamiliesModal,
    SendMessageReplyInputBox,
    SendMessageSharedReplyInputBox
  }
})
export default class SendMessageDetailTab extends Vue {
  /** 送信メッセージにひもづく家族サービス */
  @Inject("SendMessageReadFamiliesService") targetSendMessageReadFamiliesService!: SendMessageReadFamiliesService;
  /** メッセージ(既読/未読)サービス */
  @Inject("SendMessageReadCountsService") sendMessageReadCountsService!: SendMessageReadCountsService;
  /** S3Urlサービス */
  @Inject("S3UrlService") s3UrlService!: S3UrlService;
  /** メッセージ送信の返信サービス */
  @Inject("SendMessageRepliesService") sendMessageRepliesService!: SendMessageRepliesService;
  /** メッセージ送信の返信サービス(家族) */
  @Inject("SendMessageRepliesFamiliesService") sendMessageRepliesFamiliesService!: SendMessageRepliesFamiliesService;
  /** 家族ユーザーサービス */
  @Inject("FamiliesService") familiesService!: FamiliesService;

  /** 表示対象のメッセージ */
  @Prop({
    required: true
  })
  message!: SendMessageHistoryTableItem;

  /** ページ全体ローディング表示可否 */
  isBusy: boolean = false;
  /** ローディングメッセージ */
  loadingMessage: string = "";
  /** 個別メッセージ返信確認モーダル表示可否 */
  showReplyMessageModal: boolean = false;
  /** 共有メッセージ返信確認モーダル表示可否 */
  showSharedReplyMessageModal: boolean = false;
  /** メッセージ送信完了モーダル表示可否 */
  showSendMessageSuccessModal: boolean = false;

  /** 詳細領域に何を表示するか */
  showDetailType: "none" | "list" | "detail" | "sharedDetail" = "none";

  /** 返信列名 */
  replyFields: Array<SendMessageReplyListTableField> = [{ key: "message", label: "", sortable: false, sortDirection: "desc", class: "message" }];
  /** 返信メッセージ */
  replyItems: Array<SendMessageReplyListTableItem> = [];
  /** 返信のローディング表示 */
  replyLoading: boolean = true;

  /** 返信メッセージの詳細・返信で入力する返信内容 */
  replyDetailText: string = "";
  /** 返信メッセージの詳細・返信で表示するメッセージ */
  replyDetailMessage: SendMessageReplyListTableItem | null = null;
  /** 返信メッセージ送信対象のメッセージ */
  replyTargetItem: SendMessageReplyListTableItem | null = null;

  /** 共有メッセージの詳細・返信で入力する返信内容 */
  sharedReplyDetailText: string = "";
  /** 共有メッセージの詳細・返信で表示するメッセージ */
  sharedReplyDetailMessages: Array<SendMessageSharedReplyDetailBoxMessage> = [];
  /** 共有メッセージの返信対象家族が1人でも存在しているか */
  existFamilyForSharedReplyTab: boolean = false;
  /** 共有メッセージ確認済みか否か */
  sharedReaded: boolean = false;

  /** 送信メッセージの既読数 */
  readCount: number = -1;
  /** 送信メッセージの未読数 */
  unreadCount: number = -1;

  /** 既読／未読家族 */
  sendMessageReadFamilies: Array<SendMessageReadFamilyModel> | undefined = undefined;

  /** 既読／未読家族ユーザーモーダル表示可否 */
  showSendMessageReadFamiliesModal: boolean = false;
  /** 既読／未読家族ユーザーモーダルに渡す家族 */
  targetSendMessageReadFamilies: Array<SendMessageReadFamilyModel> = [];
  /** 既読／未読家族どちらか */
  sendMessageCsvTypeName: string = "";
  /** CSV出力時に使用するメッセージの件名 */
  sendMessageTitle: string = "";
  /** 既読時間を表示するか否か */
  showReadDatetime: boolean = false;

  /** ### 画面右側の表示種別を返す */
  get _detailType(): string {
    return this.showDetailType;
  }

  /** ### 返信を入力可能か否か */
  get _showReplyInput(): boolean {
    return this.message && this.message.functionContents && this.message.functionContents.addReplyButton ? true : false;
  }

  /**
   * ### vue lifecycle mounted
   */
  async mounted(): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "読込み中...";
    await this.$timerUtil.setTimeout(2000);
    await this.createView();
    this.isBusy = false;
    return;
  }

  /**
   * ### 画面表示情報を作成する
   */
  private async createView(): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "読込み中...";
    this.replyLoading = true;

    /**
     * 画面左側の情報を取得する
     * Propで受けと取っている情報が中心だが、既読／未読数はAPIリクエストする
     */
    // 必要であれば送信メッセージの既読/未読数を取得する
    if (this.message.functionContents.addReadButton && this.message.functionContents.addReadButton == true) {
      const readModel: SendMessageReadCountsModel = await this.getSendMessageReadCounts();
      this.readCount = readModel.readCounts;
      this.unreadCount = readModel.unreadCounts;
    }

    /**
     * 画面右側の情報を取得する
     * 表示方法によって取得する情報は異なる
     */
    // 右側、詳細情報の表示対象を決める
    if (this.message) {
      // 返信リストに表示する返信を取得する
      const replyMessages: Array<SendMessageReplyModel> = await this.getSendMessageReplies(Number(this.message.datetime));

      // 個別メッセージの場合、家族毎の返信を1行の情報として表示する
      if (this.message.isSharedMessages == null || this.message.isSharedMessages == false) {
        const replyItems: Array<SendMessageReplyListTableItem> = this.createReplyItems(replyMessages);
        this.replyItems = replyItems;

        this.showDetailType = "list";
      }
      // 共通メッセージの場合、全体の返信をLINEの会話風に表示する
      // 削除されていない家族が1人でもいるか、メッセージが確認済みかを確認する
      else if (this.message.isSharedMessages == true) {
        const sortedMessages: Array<SendMessageSharedReplyDetailBoxMessage> = this.createSharedReplyMessages(replyMessages);
        this.sharedReplyDetailMessages = sortedMessages;

        let existFamily: boolean = false;
        for (const receiverDetail of this.message.receiverDetails) {
          // 家族の存在チェック
          if (existFamily == false) {
            const splitedSortKey: Array<string> = receiverDetail.sortKey.split("_");
            const family: FamilyGetModel | null = await this.getFamily(Number(splitedSortKey[0]), Number(splitedSortKey[1]));
            if (family) {
              existFamily = true;
            }
          }
        }
        let sharedReaded: boolean = true;
        for (const message of sortedMessages) {
          // メッセージが全て確認済みかどうか
          if (message.senderType == SendMessageReplySenderType.FAMILY) {
            if (sharedReaded == true && !message.readUserIds.includes(userStore.loginUser.userId)) {
              sharedReaded = false;
            }
          }
        }
        this.existFamilyForSharedReplyTab = existFamily;
        this.sharedReaded = sharedReaded;

        this.showDetailType = "sharedDetail";
      }
    }

    this.replyLoading = false;
    this.isBusy = false;
    return;
  }

  /**
   * ### 送信メッセージの既読/未読数を取得する
   */
  private async getSendMessageReadCounts(): Promise<SendMessageReadCountsModel> {
    const readModel: SendMessageReadCountsModel = await this.sendMessageReadCountsService.get(userStore, this.message.datetime);
    return readModel;
  }

  /**
   * ### メッセージの返信を取得する
   */
  private async getSendMessageReplies(messageDatetime: number): Promise<Array<SendMessageReplyModel>> {
    const response: Array<SendMessageReplyModel> = await await this.sendMessageRepliesService.get(userStore, messageDatetime);
    return response;
  }

  /**
   * ### 返信リストの行情報を作成する
   */
  private createReplyItems(replies: Array<SendMessageReplyModel>): Array<SendMessageReplyListTableItem> {
    // 返信メッセージの1行はユーザーの1番古いデータになるので、datetimeの古い順にソートする
    const sortedReplies: Array<SendMessageReplyModel> = replies.sort((a, b) => a.datetime - b.datetime);

    // ユーザー単位でメッセージをMAP化する
    const map: Map<string, Array<SendMessageReplyModel>> = new Map<string, Array<SendMessageReplyModel>>();
    for (const reply of sortedReplies) {
      const messages: Array<SendMessageReplyModel> | undefined = map.get(`${reply.residentId}_${reply.familyId}`);
      if (messages) {
        messages.push(reply);
        map.set(`${reply.residentId}_${reply.familyId}`, messages);
      } else {
        map.set(`${reply.residentId}_${reply.familyId}`, [reply]);
      }
    }

    // MAP化したものを行情報にする
    const items: Array<SendMessageReplyListTableItem> = [];
    map.forEach((value: Array<SendMessageReplyModel>) => {
      const sortedValue: Array<SendMessageReplyModel> = value.sort((a, b) => a.datetime - b.datetime);

      // 未読かどうかは家族の返信で未読が存在するか否かで判断する
      let readed: boolean = true;
      for (const value of sortedValue) {
        if (value.senderType == SendMessageReplySenderType.FAMILY && !value.readUserIds.includes(userStore.loginUser.userId)) {
          readed = false;
          break;
        }
      }

      // 行の並び順は最後のメッセージの日付の新しいもの順にしたいので、行情報は最新のものを使用する
      const index: number = sortedValue.length - 1;
      const subName: string = sortedValue[index].residentRoom
        ? `${sortedValue[index].residentRoom}・${sortedValue[index].residentName}・${sortedValue[index].familyRelation}`
        : `${sortedValue[index].residentName}・${sortedValue[index].familyRelation}`;

      items.push({
        parentMessagesSortKey: sortedValue[index].parentMessagesSortKey,
        residentId: sortedValue[index].residentId,
        familyId: sortedValue[index].familyId,
        mainName: sortedValue[index].familyName,
        subName: subName,
        datetime: sortedValue[index].datetime,
        readed: readed,
        type: sortedValue[index].type as SendMessageReplyListTableType,
        messages: value,
        filterKey1: sortedValue[index].residentName + sortedValue[index].residentKanaName,
        filterKey2: sortedValue[index].residentRoom,
        filterKey3: sortedValue[index].familyName
      });
    });

    // 画面表示では日付の新しい順なのでソートしなおす
    const sortedItems: Array<SendMessageReplyListTableItem> = items.concat().sort((a, b) => b.datetime - a.datetime);

    return sortedItems;
  }

  /**
   * ### 共有メッセージ返信で表示するために返信メッセージをソートする
   */
  private createSharedReplyMessages(replies: Array<SendMessageReplyModel>): Array<SendMessageSharedReplyDetailBoxMessage> {
    // datetimeの古い順にソートする
    const sortedMessages: Array<SendMessageReplyModel> = replies.sort((a, b) => a.datetime - b.datetime);
    // 送信者を作成する
    const messages: Array<SendMessageSharedReplyDetailBoxMessage> = [];
    for (const message of sortedMessages) {
      messages.push({
        ...(message as any),
        senderName: message.senderType == SendMessageReplySenderType.FAMILY ? `${message.familyName}・${message.familyRelation}` : ""
      });
    }
    return messages;
  }

  /**
   * ### 宛先リストを表示する
   */
  async onSendTargetList(): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "読込み中...";

    if (!this.sendMessageReadFamilies) {
      this.sendMessageReadFamilies = await this.getSendMessageReadFamilies();
    }
    this.sendMessageCsvTypeName = "宛先一覧";
    this.sendMessageTitle = this.message.functionContents.title;
    this.targetSendMessageReadFamilies = this.sendMessageReadFamilies;
    this.showReadDatetime = true;

    this.isBusy = false;

    this.showSendMessageReadFamiliesModal = true;

    return;
  }

  /**
   * ### プレビューボタン押下イベント処理
   *
   * - ダイアログで送信メッセージの添付ファイルをプレビュー表示する
   */
  async onPreview(): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "読込み中...";

    const contents: any = this.message.functionContents;
    let files: Array<any> = [];
    if (contents.fileUrls) {
      for (let fileUrl of contents.fileUrls) {
        const file: File = await this.getS3File(fileUrl);
        files.push(file);
      }
    }

    const modal: SendMessageFilePreviewModal | Vue | Element | Vue[] | Element[] = this.$refs.previewModal;
    if (modal instanceof SendMessageFilePreviewModal) {
      modal.show("", false, files);
    }

    this.isBusy = false;

    return;
  }

  /**
   * ### S3に格納されているFileを取得する
   *
   * @param url 元URL
   */
  private async getS3File(url: string): Promise<File> {
    const response: File = await this.s3UrlService.getFile(userStore, Setting.backets.imageExpireHour, url);

    return response;
  }

  /**
   * ### 返信メッセージを既読にする
   */
  async onMessage(item: SendMessageReplyListTableItem): Promise<void> {
    const family: FamilyGetModel | null = await this.getFamily(item.residentId as number, item.familyId as number);
    item.isDeleted = family == null ? true : false;

    this.replyDetailMessage = item;
    this.replyDetailText = "";
    this.showDetailType = "detail";

    for (const message of item.messages as Array<SendMessageReplyModel>) {
      if (!message.readUserIds.includes(userStore.loginUser.userId)) {
        const request: SendMessageRepliesFamilyPatchModel = {
          readUserId: userStore.loginUser.userId,
          readUserName: userStore.loginUser.name,
          read: true
        };

        await this.sendMessageRepliesFamiliesService.patch(userStore, Number(this.message.datetime), message.residentId, message.familyId, message.datetime, request);

        message.readUserIds.push(userStore.loginUser.userId);
        item.readed = true;
      }
    }

    return;
  }

  /**
   * ### 家族を取得する
   *
   * - 家族単一を取得するAPIはないので、利用者にひもづく家族を取得する
   * - 家族の中から家族IDが同一のものを修正対象の家族と判断する
   */
  private async getFamily(residentId: number, familyId: number): Promise<FamilyGetModel | null> {
    const families: Array<FamilyGetModel> = await this.familiesService.getsInResident(userStore, residentId);

    for (const family of families) {
      if (family.familyId == familyId) {
        return family;
      }
    }
    return null;
  }

  /**
   * ### 既読リストを表示する
   */
  async onRead(): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "読込み中...";

    if (!this.sendMessageReadFamilies) {
      this.sendMessageReadFamilies = await this.getSendMessageReadFamilies();
    }
    const unreadFamilies: Array<SendMessageReadFamilyModel> = await this.createRreadFamilies(this.sendMessageReadFamilies);
    this.sendMessageCsvTypeName = "既読一覧";
    this.sendMessageTitle = this.message.functionContents.title;
    this.targetSendMessageReadFamilies = unreadFamilies;
    this.showReadDatetime = true;

    this.isBusy = false;

    this.showSendMessageReadFamiliesModal = true;

    return;
  }

  /**
   * ### メッセージ送信したメッセージにひもづく家族を取得する
   */
  private async getSendMessageReadFamilies(): Promise<Array<SendMessageReadFamilyModel>> {
    const families: Array<SendMessageReadFamilyModel> = await this.targetSendMessageReadFamiliesService.get(userStore, Number(this.message.datetime));
    return families;
  }

  /**
   * ### メッセージ送信したメッセージにひもづく家族から既読の家族を返却する
   */
  private createRreadFamilies(families: Array<SendMessageReadFamilyModel>): Array<SendMessageReadFamilyModel> {
    const unreadFamilies: Array<SendMessageReadFamilyModel> = [];
    for (let family of families) {
      if (family.readDatetime != undefined || family.readDatetime != null) {
        unreadFamilies.push(family);
      }
    }
    return unreadFamilies;
  }

  /**
   * ### 未読リストを表示する
   */
  async onUnread(): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "読込み中...";

    if (!this.sendMessageReadFamilies) {
      this.sendMessageReadFamilies = await this.getSendMessageReadFamilies();
    }
    const unreadFamilies: Array<SendMessageReadFamilyModel> = await this.createUnreadFamilies(this.sendMessageReadFamilies);
    this.sendMessageCsvTypeName = "未読一覧";
    this.sendMessageTitle = this.message.functionContents.title;
    this.targetSendMessageReadFamilies = unreadFamilies;
    this.showReadDatetime = false;

    this.isBusy = false;

    this.showSendMessageReadFamiliesModal = true;

    return;
  }

  /**
   * ### メッセージ送信したメッセージにひもづく家族から未読の家族を返却する
   */
  private createUnreadFamilies(families: Array<SendMessageReadFamilyModel>): Array<SendMessageReadFamilyModel> {
    const unreadFamilies: Array<SendMessageReadFamilyModel> = [];
    for (let family of families) {
      if (family.readDatetime == undefined || family.readDatetime == null) {
        unreadFamilies.push(family);
      }
    }
    return unreadFamilies;
  }

  onReply(item: SendMessageReplyListTableItem): void {
    this.showReplyMessageModal = true;
    this.replyTargetItem = item;
    return;
  }

  async registerReplyMessage(item: SendMessageReplyListTableItem): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "送信中...";

    const requestBody: SendMessageRepliesPostModel = {
      message: this.replyDetailText as string
    };
    await this.sendMessageRepliesService.post(userStore, item.parentMessagesSortKey, item.residentId as number, item.familyId as number, requestBody);

    this.isBusy = false;

    // 返信入力欄は初期化
    this.replyDetailText = "";
    // 完了モーダルにOKを押すと画面の再描画を始めるが、DBレコード登録が終わる前に実行される場合があるので2秒待つ
    await this.$timerUtil.setTimeout(2000);

    // メッセージ送信成功ダイアログを表示する
    this.showSendMessageSuccessModal = true;

    return;
  }

  async onReplySuccessOk(): Promise<void> {
    await this.createView();
    return;
  }

  onBack(): void {
    this.showDetailType = "list";
    return;
  }

  /**
   * ### 既読／未読の切り替え
   */
  async onReadSwitch(item: SendMessageReplyListTableItem): Promise<void> {
    // ローディングを表示して操作不可にしないと連打で複数かい更新が走る
    this.isBusy = true;
    this.loadingMessage = "更新中...";

    for (const message of item.messages as Array<SendMessageReplyModel>) {
      // 変更後の値
      const afterRead: boolean = !item.readed;
      // readUserIdsに自分のユーザーIDが存在すれば現在は「既読」、存在しなければ現在は「未読」
      const currentRead: boolean = message.readUserIds.includes(userStore.loginUser.userId);
      // 変更後の値と現在の値が異なる場合のみ更新が必要
      // 例：2件返信があり、1件目は既読、2件目は未読の場合は画面上「未読」として扱っている場合、2件目だけを「既読」にしないと同じuserIdが複数登録されてしまう
      if (afterRead != currentRead) {
        const request: SendMessageRepliesFamilyPatchModel = {
          readUserId: userStore.loginUser.userId,
          readUserName: userStore.loginUser.name,
          read: afterRead
        };

        await this.sendMessageRepliesFamiliesService.patch(userStore, Number(this.message.datetime), message.residentId, message.familyId, message.datetime, request);

        if (afterRead) {
          message.readUserIds.push(userStore.loginUser.userId);
        } else {
          const index: number = message.readUserIds.indexOf(userStore.loginUser.userId);
          message.readUserIds.splice(index, 1);
        }
      }
    }
    // 最後に既読／未読を反転させる
    item.readed = !item.readed;

    this.isBusy = false;

    return;
  }

  /**
   * ### 共通メッセージ表示コンポーネントからの返信ボタン押下イベント
   */
  onSharedReply(): void {
    this.showSharedReplyMessageModal = true;
    return;
  }

  /**
   * ### 共通メッセージの返信メッセージを送信する
   */
  async registerSharedReplyMessage(): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "送信中...";

    const requestBody: SendMessageRepliesPostModel = {
      message: this.sharedReplyDetailText as string
    };
    await this.sendMessageRepliesService.post(userStore, this.message.sortKey, 0, 0, requestBody);

    // 返信入力欄は初期化
    this.sharedReplyDetailText = "";
    // 完了モーダルにOKを押すと画面の再描画を始めるが、DBレコード登録が終わる前に実行される場合があるので2秒待つ
    await this.$timerUtil.setTimeout(2000);

    this.isBusy = false;

    // メッセージ送信成功ダイアログを表示する
    this.showSendMessageSuccessModal = true;

    return;
  }

  /**
   * ### 共通メッセージの既読／未読の切り替え
   */
  async onSharedReadSwitch(): Promise<void> {
    // ローディングを表示して操作不可にしないと連打で複数回更新が走る
    this.isBusy = true;
    this.loadingMessage = "更新中...";

    // 変更後の値にするために反転する
    this.sharedReaded = !this.sharedReaded;

    for (const message of this.sharedReplyDetailMessages) {
      // 施設から家族への返信はスキップ
      if (message.senderType != SendMessageReplySenderType.FAMILY) {
        continue;
      }

      // readUserIdsに自分のユーザーIDが存在すれば現在は「既読」、存在しなければ現在は「未読」
      const currentRead: boolean = message.readUserIds.includes(userStore.loginUser.userId);
      // 変更後の値と現在の値が異なる場合のみ更新が必要
      // 例：2件返信があり、1件目は既読、2件目は未読の場合は画面上「未読」として扱っているため、2件目だけを「既読」にしないと同じuserIdが複数登録されてしまう
      if (this.sharedReaded != currentRead) {
        const request: SendMessageRepliesFamilyPatchModel = {
          readUserId: userStore.loginUser.userId,
          readUserName: userStore.loginUser.name,
          read: this.sharedReaded
        };

        await this.sendMessageRepliesFamiliesService.patch(userStore, Number(this.message.datetime), message.residentId, message.familyId, message.datetime, request);

        if (this.sharedReaded) {
          message.readUserIds.push(userStore.loginUser.userId);
        } else {
          const index: number = message.readUserIds.indexOf(userStore.loginUser.userId);
          message.readUserIds.splice(index, 1);
        }
      }
    }

    this.isBusy = false;

    return;
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";
@import "../../../styles/pc/_mixin.scss";

.send-message-detail {
  .contents {
    height: calc(100vh - 224px);
    max-width: 1280px;
    overflow-x: auto;

    .send-message,
    .reply-messages {
      padding-top: 20px;
    }
    .send-message {
      width: 520px;
      min-width: 520px;
    }
    .reply-messages {
      width: 754px;
      min-width: 440px;
    }
  }
}
</style>
